import React from 'react';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import UsersContext from './UsersContext';

const Container = styled.div`
    display:flex;
    align-items:center;
    justify-content:space-between;
    width:100%;
`;

const Title = styled.div`
    color: rgba(0, 0, 0, 0.87);
    font-family: Roboto;
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0.25px;
    line-height: 24px;
    text-align: left;
`;

const Counts = styled.span`
    color: rgba(0, 0, 0, 0.87);
    font-family: Roboto;
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0.25px;
    line-height: 24px;
    text-align: left;
`;

const UsersListHeader = props => {
    return <UsersContext.Consumer>
        {context =>
            <Container>
                <Title>Users
                    {context.filteredUsers && context.users && context.filteredUsers.length != context.users.users.length ?
                        <Counts>({context.filteredUsers.length}/{context.users.users.length})</Counts>
                        :
                        <Counts>({context.users.users ? context.users.users.length : 0})</Counts>
                    }
                </Title>
                <Button onClick={() => context.updateAddingUser(true)}>+ ADD</Button>
            </Container>
        }
    </UsersContext.Consumer >
}



export default UsersListHeader;